import { Component, OnDestroy, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { Subscription } from 'rxjs/Subscription';
import { BonusService } from '@app/core/bonus.service';
import { Router } from '@angular/router';
import { ModalService } from '@app/shared/modal.service';

const logger = new Logger(`deposit-bonus.component.ts`);

@Component({
  selector: 'app-deposit-bonus-notice',
  template: `
    <div class="notice" *ngIf="available > 0 && !hasEnabled">
      <div class="icon"><i class="fal fa-gift"></i></div>
      <div class="text">Don't miss your chance! Before depositing, activate your <strong>Welcome Package</strong>!</div>
      <a href="/account/bonus" class="button" (click)="openBonuses($event)">Show my bonuses</a>
    </div>
    <div class="notice" *ngIf="available > 0 && hasEnabled && enabled">
      <div class="icon"><i class="fal fa-gift"></i></div>
      <div class="text">{{ enabled.description }}</div>
      <a href="/account/bonus" class="button" (click)="openBonuses($event)">Show my bonuses</a>
    </div>
  `,
  styles: [
    `
      .notice {
        border: 1px solid #3ab583;
        border-radius: 3px;
        background: #1f3849;
        background: rgba(58, 181, 131, 0.1);
        padding: 10px;
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
      }

      .button {
        flex: 0 0 auto;
        max-width: 118px;
        border: 0;
        border-radius: 6px;
        background-color: #3ab583;
        color: #fff;
        padding: 10px;
        line-height: 1;
        float: right;
        -webkit-transition: background-color 0.3s;
        -moz-transition: background-color 0.3s;
        -ms-transition: background-color 0.3s;
        -o-transition: background-color 0.3s;
        transition: background-color 0.3s;
        white-space: nowrap;
        text-align: center;
      }

      .button:hover {
        background-color: rgba(58, 181, 131, 0.95);
      }

      .icon {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        color: #fff;
        background: #283752;
        border-radius: 3px;
        flex: 0 0 auto;
        margin: 0 0 0 5px;
      }

      .text {
        flex: 1 1 auto;
        font-size: 11px;
        padding: 0 15px;
      }

      .text strong {
        color: #e7ce3e;
      }
    `,
  ],
})
export class DepositBonusComponent implements OnInit, OnDestroy {
  public hasEnabled: boolean = false;
  public available: number = 0;
  public enabled: DepositPromotionInterface;
  private _loadingSubscription: Subscription;

  constructor(private bonusService: BonusService, private router: Router, private modalService: ModalService) {}

  ngOnInit() {
    this.loadBonuses();
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  public openBonuses($event: Event): void {
    $event.preventDefault();
    this.router.navigateByUrl('/account/bonus');
  }

  private loadBonuses(): void {
    this.unsubscribe();
    this._loadingSubscription = this.bonusService.getDepositBonuses().subscribe(
      response => {
        this.calculate(response.items);
      },
      response => {
        logger.error(response);
      }
    );
  }

  private unsubscribe(): void {
    if (this._loadingSubscription) {
      this._loadingSubscription.unsubscribe();
    }
  }

  private calculate(items: Array<DepositPromotionInterface>): void {
    this.hasEnabled = items.filter(item => item.status === 'active').length > 0;
    this.available = items.filter(item => item.status === 'inactive').length;
    this.enabled = items.find(item => item.status === 'active');

    const welcome = items.filter(
      item => item.status === 'inactive' && item.sequenceName === 'welcome-pack' && item.sequenceOrder === 1
    );
    if (!this.hasEnabled && welcome.length) {
      this.modalService
        .openDepositPromotion(welcome)
        .result.then(result => {
          logger.info('Closed promo modal: ', result);
          if (result === 0) {
            this.loadBonuses();
          }
        })
        .catch(e => logger.error(e));
    }
  }
}

export interface DepositPromotionInterface {
  _id: string;
  name: string;
  description: string;
  status: string;
  sequenceName: string;
  sequenceOrder: number;
  activateUntil: Date;
  wagerDays: number;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/deposit-bonus.component.ts